import React from 'react'

export default function Footer() {
  return (
    <div className="footer">
        <h4 className="copyright">Copyrights &copy; my-todolist.com</h4>
    </div>
  )
}
